import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useFirestoreConnect } from 'react-redux-firebase'

function RedditMerge(props) {

  useFirestoreConnect([
    { collection: 'reddit2' },
    { collection: 'reddit4' }
  ])


  const restaurants = useSelector((state)=>state.firestore.data.restaurants)

  const data = useSelector(
    ({ firestore: { data } }) => data.reddit2 && data.reddit2
  );
  const data2 = useSelector(
    ({ firestore: { data } }) => data.reddit4 && data.reddit4
  );

  // const data = useSelector((state)=>state.firestore.data.reddit);
  // const data2 = useSelector((state)=>state.firestore.data.reddit2);

  const [finalData, setFinalData] = useState(false);

  const restaurant = props.restaurant;

  const [parsedDates, setParsedDates] = useState(false);

  useEffect(()=>{
    if(data){
    console.log('data')
    console.log(Object.entries(data)[0][1]['postId'])
    }
  },[data])

  useEffect(()=>{
    console.log('data2')
    if(data && data2){
      let data2Id = Object.entries(data2)[0][1]['postId'];
      let dataId = Object.entries(data)[0][1]['postId'];
  
      for(let id in data2Id){
        console.log(data2Id[id])
        
      }
    }
  },[data2])

  useEffect(()=>{
    console.log('both')
    if(data && data2){
      let data2Id = Object.entries(data2)[0][1]['postId'];
      let dataId = Object.entries(data)[0][1]['postId'];

      let dataIdArr = []
      for(let itm in Object.entries(dataId)){
        dataIdArr.push(Object.entries(dataId)[itm][1])
      }
      let data2IdArr = []
      for(let itm in Object.entries(data2Id)){
        data2IdArr.push(Object.entries(data2Id)[itm][1])
      }
      console.log(dataIdArr)
      console.log(data2IdArr)

      for(let itm in data2IdArr){
        console.log(data2IdArr[itm])
        if(dataIdArr.includes(data2IdArr[itm])){
          console.log('true')
        }
        else{
          console.log('false')
        }
      }
    }
  },[data,data2])

  
  return (
    <div>
        
    </div>
  );
}

export default RedditMerge;